// CompanionshipCare.js
import React from 'react';
import ServiceHero from '../components/ServiceHero';
import WarmCompanionCareSection from '../components/WarmCompanionCareSection';
import CaregiversEngageSection from '../components/CaregiversEngageSection';
import ThreeStepsSection from '../components/ThreeStepsSection';
import EnrichingLivesSection from '../components/EnrichingLivesSection';
import AllServicesShowcase from '../components/AllServicesShowcase';

const CompanionshipCare = () => {
  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Home Care Services', link: '/services' },
    { label: 'Companionship Care', link: null }
  ];

  return (
    <div className="min-h-screen bg-white">
      <ServiceHero
        breadcrumbs={breadcrumbs}
        title="Caring Companions In The Comfort Of Home"
        description="We enjoy spending time with aging-in-place seniors and are happy to provide companionship and any other assistance that's needed."
      />
      <WarmCompanionCareSection />
      <CaregiversEngageSection />
      <ThreeStepsSection />
      <EnrichingLivesSection />
      <AllServicesShowcase />
    </div>
  );
};

export default CompanionshipCare;
